import { IAction } from '..';

export type IModal =
    | 'Builder/SavePath'
    | 'Builder/Examples'
    | 'Builder/TaskDetails'
    | 'Builder/PathTaskDetails'
    | 'Builder/PathPrice'
    | null;

export interface IModalState {
    open: IModal;
}

const initialState: IModalState = {
    open: null,
};

export function reducer(state: IModalState = initialState, action: IAction): IModalState {
    switch (action.type) {
        case 'OPEN_MODAL':
            return {
                ...state,
                open: action.modal,
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                open: null,
            };
        default:
            return state;
    }
}
